import { gql } from 'urql';

const gqlQuery = gql`
  query V2ATransferUtilizationMessage(
    $input: V2ATransferUtilizationMessageInput!
  ) {
    v2aTransferUtilizationMessage(input: $input) {
      __typename
      ... on V2ATransferUtilizationMessageSuccess {
        id
        successTitle
        successMessage
      }
      ... on V2ATransferUtilizationMessageError {
        code
        message
        title
      }
    }
  }
`;

export default gqlQuery;
